import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import * as React from 'react';
import { useState } from 'react';
import moment from 'moment';

interface IDatePickerFilter {
  disabled?: boolean;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
  onDatesChange: Function;
  onFocusChange?: Function;
}

const DateRangePickerWrapper: React.FC<IDatePickerFilter> = (props) => {
  const [focusedInput, setFocusedInput] = useState(null);
  const startDate = props.startDate ? moment(props.startDate) : null;
  const endDate = props.endDate ? moment(props.endDate) : null;

  const handleChangeFocus = (isFocused)=>{
    setFocusedInput(isFocused);
    if(!isFocused && props.onFocusChange){
      props.onFocusChange();
    }
  };

  return <DateRangePicker
    disabled={props.disabled}
    startDateId="startDate" // PropTypes.string.isRequired,
    endDateId="endDate" // PropTypes.string.isRequired,
    startDate={startDate}
    endDate={endDate}
    onDatesChange={props.onDatesChange} // PropTypes.func.isRequired,
    onFocusChange={handleChangeFocus}
    focusedInput={focusedInput}
    keepOpenOnDateSelect={true}
    isOutsideRange={() => false}
    minimumNights={0}
  />;
};

export { DateRangePickerWrapper };
